import React, {useContext} from "react";
import {useParams} from "react-router-dom";
import "./index.scss";
import {Header} from "../../layout/Header";
import {Button} from "../../components/Button";
import config from "../../config";
import {getQuotationPaymentPageUrl} from "../../api/identificationApi";
import {strings} from "../../strings/strings";
import {ProcessingContext} from "../../contexts/ProcessingContext";
import {ProductType} from "../../api/model/common";


const ProductUrlsMap = {
    [ProductType.EMTPL]: config.verification.successfulQuotationURL,
    [ProductType.TRAVEL]: config.verification.travelSuccessfulQuotationURL,
    [ProductType.GREEN_CARD]: config.verification.greenSuccessfulQuotationURL
};

interface UnsuccessfulPaymentComponentProps {
    homeUrl: string
    type: ProductType
}

export const UnsuccessfulPaymentComponent = (props: UnsuccessfulPaymentComponentProps) => {
    const {homeUrl, type} = props
    const {quotationId} = useParams<any>();
    const {setProcessingOpen} = useContext(ProcessingContext);

    const wait = (quotationId: string, path: string) => {
        window.location.href = `${ProductUrlsMap[path]}/${quotationId}`;
    };

    const pay = (quotationId: string, path: ProductType) => {
        setProcessingOpen(true);
        getQuotationPaymentPageUrl(quotationId, path).then(paymentPageUrl => {
            window.location.href = paymentPageUrl;
            setProcessingOpen(false);
        });
    };

    return (
        <div className={"unsuccessful-payment"}>
            <div className={"unsuccessful-payment__header"}>
                <Header homeUrl={homeUrl} type={type}/>
            </div>

            <div className={"unsuccessful-payment__content"}>
                <div className="unsuccessful-payment__content__left">
                    <div className="unsuccessful-payment__content__left__text">
                        <h1>{strings.problem}</h1>

                        <p>{strings.unsuccessfulPayment1}</p>
                        <p>{strings.unsuccessfulPayment2}</p>
                        <p>{strings.unsuccessfulPayment3}</p>
                    </div>
                    <div className="unsuccessful-payment__content__left__form fluid">
                        <div className={"unsuccessful-payment__content__left__element"}>
                            <Button label={strings.wait} type={"button"} onClickListener={() => wait(quotationId, type)}/>
                        </div>
                        <div className={"unsuccessful-payment__content__left__element"}>
                            <Button label={strings.pay} type={"button"} onClickListener={() => pay(quotationId, type)}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};